
import ActionBox from "@/components/Base/Actions/ActionBox.vue";
import ActionBoxExit from "@/components/Base/Actions/ExitActions/ActionBoxExit.vue";
import { ChallengeData } from "@/models/Base/ChallengeData";
import { Game } from "@/models/Game";
import { ActionList } from "@/models/MapPois/Quest/Actions";
import { GoalsList } from "@/models/MapPois/Quest/Goals";
import { Quests, Q_StatusGoal_w_detail } from "@/models/MapPois/Quest/Quests";
import { Q_QUEST_STATUS } from "@/models/MapPois/Quest/QuestsEnum";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

@Component({
  components: {
    ActionBox,
    ActionBoxExit,
  },
})
class QuestStatusUnlocked extends Vue {
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: null }) readonly questData!: Quests;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;

  get getQuestData(): Q_StatusGoal_w_detail {
    return this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED];
  }

  get getExitGoals(): GoalsList | undefined {
    if (
      this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED].exitGoals !==
      undefined
    ) {
      return this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED].exitGoals;
    }
    return {} as GoalsList;
  }

  get getActionList(): ActionList | undefined {
    if (
      this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED].actions !== undefined
    ) {
      return this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED].actions;
    }
    return {} as ActionList;
  }

  update(contentData: any): void {
    this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED].actions =
      contentData.contentData;
    this.onValueChanged();
  }

  updateExit(contentData: any): void {
    this.questData.statusGoals[Q_QUEST_STATUS.UNLOCKED].exitGoals =
      contentData.contentData;
    this.onValueChanged();
  }

  deleteAction(): void {
    this.onValueChanged();
  }

  deleteActionExit(): void {
    this.onValueChanged();
  }

  onValueChanged(): void {
    this.$emit("updateTempObject", this.questData);
  }
  @Validations()
  validations = {
    getQuestData: {
      goalTitle: {
        en: {
          required,
          minValue: minLength(3),
          maxValue: maxLength(160),
        },
      },
      goalDesc: {
        en: {
          required,
          minValue: minLength(3),
          maxValue: maxLength(1000),
        },
      },
    },
  };
}

export default QuestStatusUnlocked;
